const Schemes = {
  _: '',
  ALIA_CARD: 'alia_card',
  AMEX: 'amex',
  ARGENCARD: 'argencard',
  AURA: 'aura',
  BANCNET: 'bancnet',
  BANCOMAT: 'bancomat',
  BANCONTACT: 'bancontact',
  CABAL: 'cabal',
  CARDOBESA: 'cardobesa',
  CB: 'cb',
  CENCOSUD: 'cencosud',
  CIRRUS: 'cirrus',
  CMR_FALABELLA: 'cmr_falabella',
  CORDIAL: 'cordial',
  CUP: 'cup',
  DANKORT: 'dankort',
  DINERS: 'diners',
  DISCOVER: 'discover',
  ELO: 'elo',
  EPS: 'eps',
  GIROCARD: 'girocard',
  HIPERCARD: 'hipercard',
  INTERAC: 'interac',
  JCB: 'jcb',
  J_DEBIT: 'j_debit',
  LIDER: 'lider',
  MAESTRO: 'maestro',
  MAGNA: 'magna',
  MASTERCARD: 'mastercard',
  MASTERPASS: 'masterpass',
  MERCADO_LIVRE: 'mercado_livre',
  MIR: 'mir',
  MY_DEBIT: 'my_debit',
  NARANJA: 'naranja',
  NATIVA: 'nativa',
  NETS: 'nets',
  OCA_CARD: 'oca_card',
  PRESTO: 'presto',
  RUPAY: 'rupay',
  TARJETA_SHOPPING: 'tarjeta_shopping',
  TROY: 'troy',
  VISA: 'visa',
};

module.exports = Schemes;
